import api from 'lib/api'
import { to } from 'nh-utils'

export const getSample = () => to(api.get('/sample'))
export const genericPost = payload => to(api.post('/sample', payload))
